import { HomePrice, productMap_home } from 'content/products/uhHome';
import { PhotonPrice, productMap_photon } from 'content/products/photon';
import { productMap_diesel_ring } from 'content/products/dieselRing/productMap';
import { DieselRingType } from 'content/products/dieselRing/productMap/enums';
import { RareRingAndRelatedProductsIdMap } from 'content/products/rare/productMap/constants';
import { RingAirPlainProductId } from 'content/products/ring/ringAirProductIds';
import { RING_PRO_VARIANTS_DATA_EXPANDED } from 'content/products/ring-pro/ringProVariantIds';
import { getRingProBasePrice } from 'content/products/ring-pro/tierPricing';
import type { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import type { Currency } from 'utils/Currency';

export type TripleWhaleProductKey =
  | 'ring-air'
  | 'ring-pro'
  | 'diesel'
  | 'rare'
  | 'home'
  | 'photon';

export type TripleWhaleProductIdentity = {
  name: string;
  id?: string;
  variant?: string;
  price?: number;
};

type StoreVariant = { id?: string };

function firstRingProVariant(store: ShopifyStore): string | undefined {
  for (const sizes of Object.values(RING_PRO_VARIANTS_DATA_EXPANDED)) {
    if (!sizes || typeof sizes !== 'object') continue;
    for (const engraving of Object.values(sizes)) {
      const row = engraving as {
        N?: Partial<Record<ShopifyStore, StoreVariant>>;
        E?: Partial<Record<ShopifyStore, StoreVariant>>;
      };
      const id = row?.N?.[store]?.id ?? row?.E?.[store]?.id;
      if (id) return id;
    }
  }
  return undefined;
}

function firstDieselVariant(store: ShopifyStore): string | undefined {
  for (const sizes of Object.values(productMap_diesel_ring)) {
    if (!sizes) continue;
    for (const types of Object.values(sizes)) {
      const id = types?.[DieselRingType.NOT_ENGRAVED]?.variantId?.[store];
      if (id) return id;
    }
  }
  return undefined;
}

export function tripleWhaleProduct(
  key: TripleWhaleProductKey,
  store: ShopifyStore,
  currency?: Currency,
): TripleWhaleProductIdentity {
  switch (key) {
    case 'ring-air':
      return {
        name: 'Ultrahuman Ring AIR',
        id: RingAirPlainProductId[store],
      };
    case 'ring-pro':
      return {
        name: 'Ultrahuman Ring PRO',
        variant: firstRingProVariant(store),
        price:
          currency === undefined
            ? undefined
            : getRingProBasePrice(store, currency),
      };
    case 'diesel':
      return {
        name: 'Ultrahuman Ring Diesel',
        variant: firstDieselVariant(store),
      };
    case 'rare':
      return {
        name: 'Ultrahuman Ring RARE',
        id: RareRingAndRelatedProductsIdMap[store]?.[0],
      };
    case 'home':
      return {
        name: 'Ultrahuman Home',
        variant: productMap_home.variantId[store],
        price: HomePrice[store],
      };
    case 'photon':
      return {
        name: 'Ultrahuman Photon',
        variant: productMap_photon.variantId[store],
        price: PhotonPrice[store],
      };
  }
}
